// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"60b7bfa1","166":"2a1d1b19","201":"a9b3ebc9","223":"28b9efbe","346":"e64e52a3","430":"6be17629","450":"42715418","453":"6a010d15","664":"f42c7fb6","713":"028f2dc9","834":"b54a5fe2","861":"6d662468","885":"a5199b8a"}[chunkId] + ".chunk.js";
};